"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TileDataContext_1 = require("../components/TileDataContext");
var TagIds_1 = __importDefault(require("../constants/TagIds"));
function useShowNav() {
    var _a = (0, TileDataContext_1.useTileDataContext)().tileData, _b = _a.vehicleTags, vehicleTags = _b === void 0 ? [] : _b, previousPrice = _a.previousPrice;
    var showEVCreditCard = vehicleTags.some(function (t) { return t.tagId === TagIds_1.default.EVCredit; });
    var showGreatDealCard = vehicleTags.some(function (t) { return t.tagId === TagIds_1.default.GreatDeal; });
    var showPriceDropCard = Boolean(previousPrice);
    return showPriceDropCard || showGreatDealCard || showEVCreditCard;
}
exports.default = useShowNav;
//# sourceMappingURL=useShowNav.js.map